import Point from "./Point";
export function simplify(_data, sport) {
    if (_data.length === 0) {
        return [];
    }
    const data = [..._data];
    const toolMaps = {};
    const modif = [];
    const moveMap = {};

    let i = 0;
    for (const datum of data) {
        if (!datum) {
            continue;
        }
        const id = getId(datum);
        if (datum.t === "shadeTextbox" || datum.t === "setColor") {
            modif.push(datum);
        } else if (datum.t === "move") {
            moveMap[id] = datum;
        } else if (id in toolMaps) {
            toolMaps[id].d.push(datum);
        } else {
            toolMaps[id] = {};
            toolMaps[id].d = [datum];
            toolMaps[id].index = i++;
        }
    }

    let result = new Array(toolMaps.length);
    for (const key in toolMaps) {
        const tool = flatten(toolMaps[key].d, sport);
        if (tool) {
            const index = toolMaps[key].index;
            result[index] = tool;
        }
    }

    result = result.filter((t) => !!t);
    result.push(...Object.values(moveMap));
    result.push(...modif);

    return result;
}

function flatten(actions, sport) {
    for (let i = 1; i < actions.length; i++) {
        switch (actions[i].t) {
            case "setTextboxPosition":
                if (["circle", "circleOutline"].includes(actions[0].d[6])) {
                    const startX = actions[0].d[3];
                    const startY = actions[0].d[4];
                    const endX = actions[0].d[8];
                    const endY = actions[0].d[9];
                    const start = new Point(startX, startY);
                    const cur = new Point(endX, endY);
                    const r = cur.distTo(start);
                    const dx = cur.x - start.x;
                    const dy = cur.y - start.y;
                    actions[0].d[3] = actions[i].d[2] + r;
                    actions[0].d[4] = actions[i].d[1] + r;
                    actions[0].d[8] = actions[0].d[3] + dx;
                    actions[0].d[9] = actions[0].d[4] + dy;
                } else if (["rect", "rectOutline"].includes(actions[0].d[6])) {
                    const startX = actions[0].d[3];
                    const startY = actions[0].d[4];
                    const endX = actions[0].d[8];
                    const endY = actions[0].d[9];
                    const width = Math.abs(endX - startX);
                    const height = Math.abs(endY - startY);
                    actions[0].d[3] = actions[i].d[2];
                    actions[0].d[4] = actions[i].d[1];
                    actions[0].d[8] = actions[i].d[2] + width;
                    actions[0].d[9] = actions[i].d[1] + height;
                } else {
                    actions[0].d[3] = actions[i].d[2];
                    actions[0].d[4] = actions[i].d[1];
                }
                break;
            case "changeOffense":
                if (actions[i].d.length >= 4) {
                    actions[0].d[6] =
                        "offense:" + actions[i].d[3].toLowerCase();
                } else {
                    const letter = offenseTools(sport)[actions[i].d[1]];
                    actions[0].d[6] = "offense:" + letter.toLowerCase();
                }
                break;
            case "changeDefense":
                if (actions[i].d.length >= 4) {
                    actions[0].d[6] =
                        "defense:" + actions[i].d[3].toLowerCase();
                } else {
                    const letter = defenseTools(sport)[actions[i].d[1]];
                    actions[0].d[6] = "defense:" + letter.toLowerCase();
                }
                break;
            case "editBezierLine":
                actions[0].d = actions[i].d;
                break;
            case "editMultiline": {
                // Keep the original group origin for existing move actions.
                const origin = actions[0].pointOrigin || {
                    x: Math.min(...actions[0].d.map((point) => point.x)),
                    y: Math.min(...actions[0].d.map((point) => point.y)),
                };
                actions[0].pointOrigin = origin;
                actions[0].d = actions[i].d[1].map((point) => ({
                    x: point.x + origin.x,
                    y: point.y + origin.y,
                }));
                break;
            }
            case "remove":
            case "removeTextbox":
                return null;
            case "pen":
            case "penArrow":
            case "penTab":
            case "penDotted":
            case "penDottedArrow":
                actions[0].d.push(...actions[i].d);
                break;
        }
    }

    return actions[0];
}

export function getId(datum) {
    switch (datum.t) {
        case "addTextBox":
            return datum.d[5];
        case "bezierLine":
        case "bezierLineDashed":
        case "editBezierLine":
            return datum.d[8];
        case "changeOffense":
        case "changeDefense":
        case "changeIcon":
        case "setTextboxPosition":
        case "removeTextbox":
        case "move":
        case "editMultiline":
        case "remove":
        case "setColor":
        case "shadeTextbox":
        case "lineAcross":
        case "text":
        case "resizeCircle":
        case "resizeRect":
            return datum.d[0];
        default:
            return datum.t + datum.drawId;
    }
}

export function loadImageAsset(url, width, height) {
    return new Promise((resolve, reject) => {
        let image = new Image();
        image.width = width;
        image.height = height;
        image.onload = function () {
            resolve(image);
        };
        image.onerror = function () {
            console.log("error");
            reject();
        };
        image.src = url;
    });
}

/**
 * Compute the euclidean distance between two points
 * @param {Point} p1
 * @param {Point} p2
 */
export function computeDist(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}

/**
 * Return the current time in ms since 1970
 * @returns {number}
 */
export function getCurrentTimeMs() {
    return new Date().getTime();
}

export function getSubDir() {
    const url = document.URL.substr(0, document.URL.lastIndexOf("/"));
    const urlSplit = url.split("/");
    let subdir = "";
    for (let i = 3; i < urlSplit.length; i++) {
        subdir = subdir + "/" + urlSplit[i];
    }

    return subdir;
}

export function isTablet() {
    const userAgent = navigator.userAgent.toLowerCase();
    console.log({ userAgent: navigator.userAgent });
    const isTablet =
        /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
            userAgent
        );
    return isTablet;
}

export function rgbaWithOpacity(rgba, alpha) {
    let rgbaValues = rgba.match(/\d+/g).map(Number);
    let [r, g, b, a] = rgbaValues;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function measureActualPos(num, maxW) {
    return (num / maxW) * window.innerWidth;
}

export function pathsToPoints(paths) {
    let points = [];
    for (let i = 0; i < paths.length; i += 2) {
        points.push(new Point(paths[i], paths[i + 1]));
    }

    return points;
}

export function pointsToPaths(points) {
    let paths = [];
    for (let i = 0; i < points.length; i++) {
        paths.push(points[i].x, points[i].y);
    }
    return paths;
}

export function hexToRgbA(hex) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
            "rgba(" +
            [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
            ",1)"
        );
    }
    throw new Error("Bad Hex");
}

export function offenseTools(sport) {
    switch (sport) {
        case "basketball":
            return BASKETBALL_OFFENSE_TOOLS;
        default:
            return FOOTBALL_OFFENSE_TOOLS;
    }
}

const FOOTBALL_OFFENSE_TOOLS = [
    "F",
    "X",
    "Y",
    "Z",
    "H",
    "Q",
    "TE",
    "TE2",
    "R",
    "WR1",
    "WR2",
    "WR3",
    "WR4",
];

const BASKETBALL_OFFENSE_TOOLS = [
    "PG",
    "SG",
    "SF",
    "PF",
    "C",
    "1",
    "2",
    "3",
    "4",
    "5",
    "BASKET-PG",
    "BASKET-SG",
    "BASKET-SF",
    "BASKET-PF",
    "BASKET-C",
    "BASKET-1",
    "BASKET-2",
    "BASKET-3",
    "BASKET-4",
    "BASKET-5",
];

export function defenseTools(sport) {
    switch (sport) {
        case "basketball":
            return BASKETBALL_DEFENSE_TOOLS;
        default:
            return FOOTBALL_DEFENSE_TOOLS;
    }
}

const FOOTBALL_DEFENSE_TOOLS = [
    "M",
    "W",
    "S",
    "DB",
    "LB",
    "FS",
    "SS",
    "CB",
    "DE",
    "NT",
    "DT",
    "T",
    "U",
    "$",
    "D",
    "L",
    "B",
    "WS",
];

const BASKETBALL_DEFENSE_TOOLS = [
    "X-PG",
    "X-SG",
    "X-SF",
    "X-PF",
    "X-C",
    "X-1",
    "X-2",
    "X-3",
    "X-4",
    "X-5",
];

export const ICONS = [
    "anchor-outline",
    "trophy-outline",
    "barbell-outline",
    "book-outline",
    "bus-outline",
    "cash-outline",
    "checkmark-outline",
    "checkmark-done-outline",
    "construct-outline",
    "dice-outline",
    "earth-outline",
    "eye-outline",
    "flame-outline",
    "flash-outline",
    "game-controller-outline",
    "gift-outline",
    "hammer-outline",
    "hand-left-outline",
    "happy-outline",
    "heart-outline",
    "heart-dislike-outline",
    "home-outline",
    "hourglass-outline",
    "key-outline",
    "lock-closed-outline",
    "magnet-outline",
    "mail-outline",
    "map-outline",
    "mic-outline",
    "pint-outline",
    "planet-outline",
    "power-outline",
    "pulse-outline",
    "restaurant-outline",
    "rocket-outline",
    "sad-outline",
    "shield-outline",
    "skull-outline",
    "star-outline",
    "telescope-outline",
    "thumbs-down-outline",
    "thumbs-up-outline",
    "thunderstorm-outline",
    "transgender-outline",
    "trash-outline",
];

export function isValidTool(tool) {
    return [
        "multilineArrow",
        "multilineDashedArrow",
        "multilineHammer",
        "multilineDotted",
        "multiline",
        "line",
        "pen",
        "penArrow",
        "penSquigglyArrow",
        "penSquigglyTab",
        "penSquigglyFirstArrow",
        "penSquigglyFirstTab",
        "penTab",
        "penDotted",
        "penDottedArrow",
        "penDottedCircle",
        "penCircle",
        "multilineTouch",
        "multilineHammerTouch",
        "multilineArrowTouch",
        "multilineDashedArrowTouch",
        "rectOutline",
        "circleOutline",
        "rect",
        "circle",
        "arrow",
        "dotted",
        "dottedArrow",
        "arrowTab",
        "arrowDootedTab",
        "eraser",
        "addImgBG",
        "recSelect",
        "eraseRec",
        "addTextBox",
        "embedImage",
        "embedVideo",
        "setEmbedPosition",
        "setEmbedSize",
        "removeEmbed",
        "setTextboxText",
        "removeTextbox",
        "setTextboxPosition",
        "setTextboxFontSize",
        "setTextboxFontColor",
        "setTextboxBackgroundColor",
        "shadeTextbox",
        "changeLetter",
        "changeOffense",
        "changeDefense",
        "changeIcon",
        "clearCanvas",
        "move",
        "remove",
        "bezierLine",
        "bezierLineDashed",
        "bezierLineTab",
        "bezierLineTabDashed",
        "editBezierLine",
        "editMultiline",
        "setColor",
        "setShadedColor",
        "setBackgroundColor",
        "clearDefenses",
        "clearOffenses",
        "text",
        "setText",
        "lineAcross",
    ].includes(tool);
}

export function drawStraightArrow2(
    ctx,
    from,
    to,
    color,
    thickness,
    arrowLength = 8,
    flatness = 4
) {
    const firstVector = from;
    const lastVector = to;

    const angle = Math.atan2(
        firstVector.y - lastVector.y,
        firstVector.x - lastVector.x
    );

    const inversedArrowLength = -arrowLength;
    ctx.beginPath();
    ctx.moveTo(lastVector.x, lastVector.y);
    ctx.lineTo(
        lastVector.x -
            inversedArrowLength * Math.cos(angle - Math.PI / flatness),
        lastVector.y -
            inversedArrowLength * Math.sin(angle - Math.PI / flatness)
    );
    ctx.moveTo(lastVector.x, lastVector.y);
    ctx.lineTo(
        lastVector.x -
            inversedArrowLength * Math.cos(angle + Math.PI / flatness),
        lastVector.y -
            inversedArrowLength * Math.sin(angle + Math.PI / flatness)
    );
    ctx.moveTo(lastVector.x, lastVector.y);
    // ctx.lineWidth = thickness * 2;
    // ctx.strokeStyle = color;
    // ctx.lineCap = _this.lineCap;
    ctx.closePath();
    // ctx.fillStrokeShape(shape);
    // ctx.stroke();
}

export function drawArrow2(
    ctx,
    data,
    color,
    thickness,
    arrowLength = 8,
    flatness = 4
) {
    const _this = this;
    // Some drawBuffer contains an addition that isn't actually part of the line (maybe it was the arrow? TBC)
    // so we are filtering out those additions
    /* const vectorizedData = data
        .filter((b) => b.d.length > 4)
        .map((b) => {
            return { x: b.d[b.d.length - 2], y: b.d[b.d.length - 1], d: b.d };
        }); */

    let vectorizedData = [];
    for (let i = 3; i < data.length; i += 4) {
        vectorizedData.push({
            x: data[i - 3],
            y: data[i - 2],
            d: [data[i - 3], data[i - 2], data[i - 1], data[i - 0]],
        });
    }
    // vectorizedData.reverse()

    let firstVector = { x: 0, y: 0 };
    const lastVector = vectorizedData[vectorizedData.length - 1];

    // determine the angle of the last significant movement based on the threshold below
    const deltaThreshold = 3;
    for (let i = vectorizedData.length - 2; i >= 0; i--) {
        const v = vectorizedData[i];
        if (
            Math.abs(v.x - lastVector.x) > deltaThreshold &&
            Math.abs(v.y - lastVector.y) > deltaThreshold
        ) {
            firstVector = v;
            break;
        }
        if (i === 2) {
            firstVector = v;
        }
    }
    if (!lastVector || !firstVector) {
        return;
    }

    const angle = Math.atan2(
        firstVector.y - lastVector.y,
        firstVector.x - lastVector.x
    );

    const inversedArrowLength = -arrowLength;
    ctx.beginPath();
    ctx.moveTo(lastVector.x, lastVector.y);
    ctx.lineTo(
        lastVector.x -
            inversedArrowLength * Math.cos(angle - Math.PI / flatness),
        lastVector.y -
            inversedArrowLength * Math.sin(angle - Math.PI / flatness)
    );
    ctx.moveTo(lastVector.x, lastVector.y);
    ctx.lineTo(
        lastVector.x -
            inversedArrowLength * Math.cos(angle + Math.PI / flatness),
        lastVector.y -
            inversedArrowLength * Math.sin(angle + Math.PI / flatness)
    );
    ctx.moveTo(lastVector.x, lastVector.y);
    ctx.lineWidth = thickness * 2;
    ctx.strokeStyle = color;
    ctx.lineCap = "square";
    ctx.closePath();
    ctx.stroke();
}

export function drawHammer2(ctx, data, color, thickness, hammerLength = 12) {
    let vectorizedData = [];
    for (let i = 3; i < data.length; i += 4) {
        vectorizedData.push({
            x: data[i - 3],
            y: data[i - 2],
            d: [data[i - 3], data[i - 2], data[i - 1], data[i - 0]],
        });
    }

    let firstVector = { x: 0, y: 0 };
    const lastVector = vectorizedData[vectorizedData.length - 1];

    // determine the angle of the last significant movement
    const deltaThreshold = 3;
    for (let i = vectorizedData.length - 2; i >= 0; i--) {
        const v = vectorizedData[i];
        if (
            Math.abs(v.x - lastVector.x) > deltaThreshold &&
            Math.abs(v.y - lastVector.y) > deltaThreshold
        ) {
            firstVector = v;
            break;
        }
        if (i === 2) {
            firstVector = v;
        }
    }
    if (!lastVector || !firstVector) {
        return;
    }

    // angle of line
    const angle = Math.atan2(
        firstVector.y - lastVector.y,
        firstVector.x - lastVector.x
    );

    // perpendicular angle
    const perpAngle = angle + Math.PI / 2;

    // draw hammer tab (T perpendicular to line at endpoint)
    ctx.beginPath();
    ctx.moveTo(
        lastVector.x - (hammerLength / 2) * Math.cos(perpAngle),
        lastVector.y - (hammerLength / 2) * Math.sin(perpAngle)
    );
    ctx.lineTo(
        lastVector.x + (hammerLength / 2) * Math.cos(perpAngle),
        lastVector.y + (hammerLength / 2) * Math.sin(perpAngle)
    );
    ctx.lineWidth = thickness * 2;
    ctx.strokeStyle = color;
    ctx.lineCap = "square";
    ctx.stroke();
}

export function drawBezierHammer(
    ctx,
    data,
    color,
    thickness,
    hammerLength = 12
) {
    const startX = data[0];
    const startY = data[1];
    const endX = data[2];
    const endY = data[3];
    let dx = endX - startX;
    let dy = endY - startY;
    let len = Math.sqrt(dx * dx + dy * dy);
    if (len === 0) return; // avoid divide by zero

    dx /= len; // normalize
    dy /= len;

    // 2. Get perpendicular vector
    let px = -dy;
    let py = dx;

    // 3. Draw the T line (arrow cap)
    let halfLength = hammerLength / 1.5; // length of the T crossbar
    ctx.beginPath();
    ctx.moveTo(endX - px * halfLength, endY - py * halfLength);
    ctx.lineTo(endX + px * halfLength, endY + py * halfLength);

    //set dash
    ctx.setLineDash([0, 0]);

    ctx.lineWidth = thickness * 4;
    ctx.strokeStyle = color;
    ctx.lineCap = "square";
    ctx.stroke();
}
